import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const propertyStatusService = {
    getAll,
    store,
    show,
    update,
    updateSequence,
    updateStatus,
    softDelete,
    destroy,
};

const MODULE = {
    PROPERTY_STATUS: 'property-statuses',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            show_na: filter?.showNa,
            page: filter?.pageNumber,
            size: filter?.pageSize,
            is_active: filter?.isActive,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_STATUS}`, request);
}

export function store (data) {
    const request = {
        name: data.name,
        description: data.description,
        is_operational: data.isOperational,
    };

    return apiHelper(API_URL).post(`/${MODULE.PROPERTY_STATUS}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PROPERTY_STATUS}/${uuid}`);
}

export function update (data) {
    const request = {
        name: data.name,
        description: data.description,
        is_operational: data.isOperational,
    };

    return apiHelper(API_URL).put(`/${MODULE.PROPERTY_STATUS}/${data.uuid}`, request);
}

export function updateSequence (data) {
    const request = {
        uuids: data.uuids || [],
    };

    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_STATUS}/sequence`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_STATUS}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.PROPERTY_STATUS}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.PROPERTY_STATUS}/${data.uuid}`);
}
